import { resetAllForms } from './utils';
import { clearAnimations } from './lottie';
var screensaver;

export function setScreenSaver()
{
    clearTimeout(screensaver);
    screensaver = setTimeout(startScreenSaver, 5*60*1000); // Minutes
}

function startScreenSaver()
{
    window.location.hash = 'm1';
    var screensaverEl = document.getElementById("screensaver");
    screensaverEl.style.display = "block";
    screensaverEl.classList.add("active");
    var video = screensaverEl.querySelector('video');
    if (video) {
        video.play();
    }
    resetAllForms();
    clearAnimations();
}

export function stopScreenSaver() 
{
    var screensaverEl = document.getElementById("screensaver");
    screensaverEl.style.display = "none";
    screensaverEl.classList.remove("active");
    var video = screensaverEl.querySelector('video');
    if (video) {
        video.pause();
        video.currentTime = 0;
    }
    setScreenSaver();
}
